module.exports = "<sq-audit-trail class=\"flexRowContainer flexFill\"></sq-audit-trail>\n";